/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import styles from './InsufficientData.module.scss';

@translate()
@observer
export default class InsufficientData extends React.Component<*> {
  render(): React.Element<*> {
    const { t } = this.props;

    return (
      <div className={styles['insufficient-data']}>
        {this.props.icon ? (
          <svg>
            <use xlinkHref="#icon-no-graph" />
          </svg>
        ) : null}
        {t('general:dashboards.messages.graph_unavailable')}
        <small>{t('general:dashboards.messages.graph_data_needed')}</small>
      </div>
    );
  }
}
